import React, {useEffect, useState} from "react";
import styled from "styled-components";
import ReactGA from "react-ga";
import ReactPixel from 'react-facebook-pixel';
import { isIOS } from "react-device-detect";
import MetaTags from "react-meta-tags";

import theMoreCardEvent from "../../assets/image/promotion/theMoreCardEvent.jpg";
import theMoreCardNotice from "../../assets/image/promotion/theMoreCardNotice.jpg";

const TheMoreCard = (props) => {
  const { target } = props;
  const [downloadButton, setDownloadButton] = useState(false);
  const handleDownloadButton = () => {
    if (isIOS) {
      window.location = "https://tickleinvest.app.link/website"; // TODO: links to be changed
      ReactGA.event({
        category: "appDownload",
        action: "click",
        label: "apple",
      });
    } else {
      window.location = "https://tickleinvest.app.link/website";
      ReactGA.event({
        category: "appDownload",
        action: "click",
        label: "play",
      });
    }
  };

  const handleShareButton = () => {
    var copyText = document.getElementById("copyText");
    copyText.type = "text";
    copyText.value = window.location.href;

    copyText.select();
    copyText.setSelectionRange(0, 99999);

    document.execCommand("copy");
    copyText.type = "hidden";
    alert("링크가 복사되었습니다!");
  };

  const handleDetailButton = () => {
    ReactGA.event({
      category: "theMoreCardDetail",
      action: "click",
      label: target || "1",
    });
    ReactPixel.track('AddToCart');
    if (window.ReactNativeWebView){
      const data = {
        type: "sendEvent",
        title: "register_the_more_card",
      };
      window.ReactNativeWebView.postMessage(JSON.stringify(data))
    }
    switch (Number(target)){
      case 1:
        window.location =
        "https://www.shinhancard.com/pconts/html/card/apply/credit/1198942_2207.html?EntryLoc1=TM5956&EntryLoc2=3019&empSeq=523";
        break;
      case 2:
        window.location =
        "https://www.shinhancard.com/pconts/html/card/apply/credit/1198942_2207.html?EntryLoc1=TM5957&EntryLoc2=3019&empSeq=523";
        break;
      case 3:
        window.location =
        "https://www.shinhancard.com/pconts/html/card/apply/credit/1198942_2207.html?EntryLoc1=TM5953&EntryLoc2=3019&empSeq=523";
        break;
      case 4:
        window.location =
        "https://www.shinhancard.com/pconts/html/card/apply/credit/1198942_2207.html?EntryLoc1=TM5954&EntryLoc2=3019&empSeq=523";
        break;
      case 5:
        window.location =
        "https://www.shinhancard.com/pconts/html/card/apply/credit/1198942_2207.html?EntryLoc1=TM5955&EntryLoc2=3019&empSeq=523";
        break;
      default:
        window.location =
        "https://www.shinhancard.com/pconts/html/card/apply/credit/1198942_2207.html?EntryLoc1=TM5956&EntryLoc2=3019&empSeq=523";
        break;
    }
  };

  useEffect(() => {
    if (!window.ReactNativeWebView){
      setDownloadButton(true)
    }
  }, []);

  return (
    <>
      <MetaTags>
        <title>잔돈 재테크 끝판왕 "더모아 재테크"⎜티클</title>
        <meta name="description" content="지금 18,000포인트 받고 시작해볼까?" />
        <meta
          property="og:title"
          content={`잔돈 재테크 끝판왕 "더모아 재테크"⎜티클`}
        />
        <meta
          property="og:image"
          content="http://tickleinvest.com/invite-illust-piggy-light-orange.jpg" // TODO: 썸네일 이미지 변경 필요
        />
      </MetaTags>
      <Container>
        <FullImage src={theMoreCardEvent} />
        <ButtonContainer>
          <OutlineButton onClick={handleShareButton}>
            <OutlineButtonText>친구에게 공유하기</OutlineButtonText>
          </OutlineButton>
          {downloadButton && (
            <OutlineButton onClick={handleDownloadButton} id="download">
              <OutlineButtonText>티클 앱 다운로드</OutlineButtonText>
            </OutlineButton>
          )}
        </ButtonContainer>
        <FullImage src={theMoreCardNotice} />
      </Container>
      <Button onClick={handleDetailButton}>
        <ButtonText>The More 카드 자세히 보기</ButtonText>
      </Button>
      <input id="copyText" type="hidden" readOnly />
    </>
  );
};

const Container = styled.div`
  background-color: white;
  text-align: center;
  padding-bottom: 84px;
`;

const FullImage = styled.img`
  @media (min-width: 320px) and (max-width: 768px) {
    width: 100%;
  }
  max-width: 768px;
  margin-top: 0;
  margin-bottom: 0;
`;

const Button = styled.button`
  width: calc(100% - 40px);
  height: 50px;
  position: fixed;
  bottom: 34px;
  background-color: #ff9016;
  border-radius: 10px;
  border: 0;
  margin-left: 20px;
`;
const ButtonText = styled.span`
  color: #ffffff;
  font-size: 15px;
  font-weight: bold;
`;
const ButtonContainer = styled.div`
  display: flex;
  @media (min-width: 320px) and (max-width: 768px) {
    width: calc(100% - 40px);
  }
  max-width: 688px;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
  padding-top: 24px;
  padding-bottom: 24px;
`;
const OutlineButton = styled.button`
  width: 100%;
  height: 50px;
  border: 1px solid #ff9016;
  border-radius: 10px;
  background-color: #ffffff;
  margin-top: 8px;
  margin-bottom: 8px;
`;
const OutlineButtonText = styled.span`
  color: #ff9016;
  font-size: 15px;
  font-weight: bold;
`;
export default TheMoreCard;
